import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal } from '@/utils/locals';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import EFVideo from '@/components/UI/EFVideo';
import { createEFPic } from '@/utils/useEFPic';
import AppPointRiverAdv from '@/components/AppPoint/RiverAdvH5';
import { SHOW_APP_POINT_SITES } from '@/constants';

const { EFPic } = createEFPic('/media/river2/h5/');

export default function K() {
    const { useLang, useRouter, Link } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();
    const imgLocal = getImageLocal(locale, ['cn', 'de', 'es', 'fr', 'it', 'jp', 'kr', 'nl', 'cis']);
    const appRedirect = ['us', 'ca', 'uk', 'au', 'de', 'fr', 'jp', 'cn'];

    return (
        <div className={`river2_details_K ${css.K_11}`}>
            {!SHOW_APP_POINT_SITES.includes(locale) && (
                <div className="innerBox">
                    <div className="textBox">
                        <div className="title">{t('river2.details.sec11_title')}</div>
                        <div className="logo">
                            <EFPic name={['logo.webp', 'logo.png']} alt={t('river2.details.sec11_title')} aria-label={t('river2.details.sec11_title')} />
                        </div>
                        <div className="app">{t('river2.details.sec11_app')}</div>
                        <div className="text">{t('river2.details.sec11_text')}</div>
                        {appRedirect.includes(locale) && (
                            <Link href="/app" className="link_learn" newWin target="_blank">
                                <div className="text2">{t('river2.learn_more')}</div>
                                <div className="icon">
                                    <EFArrowDown
                                        style={{
                                            fontSize: '0.15rem',
                                            transform: 'rotate(-90deg)',
                                        }}
                                    />
                                </div>
                            </Link>
                        )}
                    </div>
                    <div className="listsBox">
                        <div className="list first">
                            <EFVideo
                                sources={['/video/river2/details/h5/Bluetooth.webm', '/video/river2/details/h5/Bluetooth.mp4']}
                                className="fullImgs river2_details_K_video"
                                poster={'/media/river2/pc/11_1.jpg'}
                            />
                            <p className="list_text">{t('river2.details.sec11_list1')}</p>
                        </div>
                        <div className="list">
                            <EFVideo
                                sources={[`/video/river2/details/h5/11_${imgLocal}.webm`, `/video/river2/details/h5/11_${imgLocal}.mp4`]}
                                className="fullImgs river2_details_K_video"
                                poster={'/media/river2/pc/11_2.jpg'}
                            />
                            <p className="list_text">{t('river2.details.sec11_list2')}</p>
                        </div>
                    </div>
                </div>
            )}
            {SHOW_APP_POINT_SITES.includes(locale) && <AppPointRiverAdv local={locale} />}
        </div>
    );
}
